import React, { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../components/Button'
import Header from '../../components/Header'
import { Content } from './styles'
import Container from '../../components/Container'
import usePersistedState from '../../hooks/usePersistedState'

const Inicio: React.FC = () => {
  const [, setFlagSimulation] = usePersistedState('flagSimul', false)
  const history = useHistory()

  const handleAccession = useCallback(async () => {
    await setFlagSimulation(false)
    history.push('/accession')
  }, [history, setFlagSimulation])

  const handleSimulation = useCallback(async () => {
    await setFlagSimulation(true)
    history.push('/contribution')
  }, [history, setFlagSimulation])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <p>Deseja iniciar sua adesão?</p>
          <Button
            color="orange"
            onClick={handleAccession}
            width="large"
            fontSize="large"
          >
            Fazer adesão
          </Button>
          <br />
          <br />
          <p>Ou deseja começar a adesão fazendo uma simulação?</p>
          <Button
            color="orange"
            onClick={handleSimulation}
            width="large"
            fontSize="large"
          >
            Sim, quero simular
          </Button>
        </Content>
      </Container>
    </>
  )
}

export default Inicio
